import React, { useState, useEffect } from "react";
import { getAccessToken } from "../utils/common";
import axios from "axios";

const KyhSingleFileUploader = ({ onResult }) => {
    const [loading, setLoading] = useState(false);

    /**
     * 클라우디나리 업로드 다이렉트로 업로드
     */
    async function handleFileChange(e) {
        setLoading(true);
        const files = e.target.files;

        const file = files[0];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "recipe");

        const { data } = await axios({
            url: `https://api.cloudinary.com/v1_1/dgekrvesv/image/upload`,
            method: "POST",
            data: formData,
        });

        console.log(data);

        const fileUrl = data.secure_url;

        onResult(fileUrl);

        setLoading(false);
    }

    return (
        <>
            <input id="single_file" type="file" onChange={handleFileChange} style={{ display: "none" }} />
            {loading ? (
                <div className="d-flex lign-items-center justify-content-center">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <label
                    htmlFor="single_file"
                    className="d-flex align-items-center justify-content-center btn btn-sm btn-light border border-secondary py-2"
                >
                    파일선택
                </label>
            )}
        </>
    );
};
export default KyhSingleFileUploader;
